var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"tva-parallax"},[_c('div',{ref:"image",staticClass:"tva-image",style:({
      transform: ("translateY(-" + _vm.offset + "px)"),
      backgroundImage: ("url(" + (_vm.baseUrl + _vm.content) + ")"),
      height: (_vm.imageHeight + "%"),
      backgroundPosition: ("" + _vm.imagePosition),
      transition: ("transform " + _vm.ease + " ease-out")
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }